/** @format */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface UserToken {
  token: string;
  expires: number;
  refreshToken: string;
  service?: string;
}

export interface UserInfo {
  name: string;
  avatar: string;
}

interface AuthState {
  userToken?: UserToken;
  userInfo?: UserInfo;
  status: "idle" | "loading" | "error";
}

export const initialState: AuthState = {
  status: "idle",
  userInfo: undefined,
  userToken: undefined,
};

export const authSlice = createSlice({
  name: `auth`,
  initialState,
  reducers: {
    setUserToken(state, action: PayloadAction<UserToken | undefined>) {
      console.log("setting user");
      state.userToken = action.payload;
    },
    logout: () => initialState,
  },
});

export const { setUserToken, logout } = authSlice.actions;
export const getUserToken = (state: RootState) => state.auth.userToken;
export const getUserInfo = (state: RootState) => state.auth.userInfo;
export default authSlice.reducer;
